import { Injectable, TemplateRef, signal } from '@angular/core';

/**
 * Lets a lazily-loaded module hang its own control in the global topbar.
 *
 * The alternative — importing the control into CoreModule — would pull that module's code into
 * the eager bundle and undo its lazy loading, and it would point core at a feature module, which
 * is the wrong way round. The module hands over a TemplateRef instead; the embedded view keeps
 * its declaring injector, so the control still resolves its own module-scoped services.
 */
@Injectable({ providedIn: 'root' })
export class TopbarSlotService {
    readonly content = signal<TemplateRef<unknown> | null>(null);

    set(template: TemplateRef<unknown>): void {
        this.content.set(template);
    }

    /**
     * Only the current occupant may clear the slot: on a module swap the incoming module registers
     * before the outgoing one is destroyed, and an unconditional clear would wipe the new control.
     */
    clear(template: TemplateRef<unknown>): void {
        if (this.content() === template) this.content.set(null);
    }
}
